import { dec } from '../core/decimal.ts';
import type { DepreciationPreset, DepreciationRates } from '../types/domain.ts';

const rates = (year1: number, year2: number, year3Plus: number): DepreciationRates => ({
  year1: dec(year1),
  year2: dec(year2),
  year3Plus: dec(year3Plus),
});

/** DepreciationPreset.rates: year 1 / year 2 / year 3+ percent. */
export const PRESET_RATES: Readonly<Record<DepreciationPreset, DepreciationRates>> = {
  'vehicle-standard': rates(25, 18, 12),
  'vehicle-truck': rates(15, 12, 8),
  'vehicle-luxury': rates(35, 25, 15),
  'vehicle-electric': rates(30, 22, 10),
  electronics: rates(30, 20, 10),
  instruments: rates(5, 3, 2),
  slow: rates(10, 8, 5),
  custom: rates(0, 0, 0),
};

/** The rate for 0-based year `year` of ownership. */
export const rateForYear = (r: DepreciationRates, year: number) => (year === 0 ? r.year1 : year === 1 ? r.year2 : r.year3Plus);
